(() => {
  if (window.stickyBarPriceBindingInitialized) {
    return;
  }

  window.stickyBarPriceBindingInitialized = true;

  const STICKY_BAR_TAGS = ['sticky-buy-now-v2', 'global-sticky-buy-now-v2'];

  // Both islands read the product form id from the "Buy Now" link, so their price calculation
  // stays uninitialised (or resolves no form and renders 0) whenever that link is not rendered.
  const bindStickyBars = (tagName) => {
    document.querySelectorAll(tagName).forEach((stickyBar) => {
      const formId = stickyBar.getAttribute('form');

      if (!formId || stickyBar.formId === formId) {
        return;
      }

      stickyBar.formId = formId;
      stickyBar.form = document.getElementById(formId);
      stickyBar.initPriceCalculation?.();
    });
  };

  const init = () => {
    STICKY_BAR_TAGS.forEach((tagName) => {
      customElements.whenDefined(tagName).then(() => bindStickyBars(tagName));
    });
  };

  init();
  document.addEventListener('shopify:section:load', init);
})();
